import { styled } from "styled-components";
const ToolbarGroup = styled("div")(
  {
    alignItems: "center",
    boxSizing: "content-box",
    display: "flex",
    margin: -4,
    minWidth: 0,
    overflow: "hidden",
    padding: "4px 8px"
  },
  ({ expand }) => ({
    maxWidth: expand ? "none" : "max-content"
  }),
  ({ flex }) => flex ? {
    flex: `${flex} ${flex} 0`
  } : {
    flex: "0 0 auto"
  },
  ({ $left }) => $left ? { marginRight: "auto" } : void 0,
  ({ $right }) => $right ? { marginLeft: "auto" } : void 0
);
export {
  ToolbarGroup
};
